const calcLine = (element) => {
    if (!element) {
        return;
    }

    const bar = element.querySelector('.wpg-checkout-progress-bar');

    if (!bar) {
        return;
    }

    bar.style.height = `${percentageSeen(element, ((element.offsetHeight / 2) + 100))}%`;
};

const percentageSeen = (element, offset) => {
    // Get the relevant measurements and positions
    const viewportHeight = window.innerHeight - offset;
    const scrollTop = window.scrollY;
    const elementOffsetTop = element.offsetTop;
    const elementHeight = element.offsetHeight;

    // Calculate percentage of the element that's been seen
    const distance = scrollTop + viewportHeight - elementOffsetTop;
    const percentage = Math.round(
        distance / ((viewportHeight + elementHeight) / 100),
    );

    // Restrict the range to between 0 and 100
    return Math.min(100, Math.max(0, percentage));
};

export default () => {
    const element = document.querySelector('.wpg-checkout-form form');

    if (!element) {
        return;
    }

    // Add line
    const line = document.createElement('div');
    line.classList.add('wpg-checkout-progress-bar');
    element.appendChild(line);

    // Load
    calcLine(element);

    // Scroll
    document.addEventListener('scroll', () => {
        calcLine(element);
    });

    // Resize
    window.addEventListener('resize', () => {
        calcLine(element);
    });
}
